import { render, staticRenderFns } from "./SunIconEdit.vue?vue&type=template&id=40e17b2f&scoped=true&"
import script from "./SunIconEdit.vue?vue&type=script&lang=js&"
export * from "./SunIconEdit.vue?vue&type=script&lang=js&"
import style0 from "./SunIconEdit.vue?vue&type=style&index=0&id=40e17b2f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e17b2f",
  null
  
)

export default component.exports